
import { mapGetters } from "vuex";
import OrganizationChart from "vue-organization-chart";
import "vue-organization-chart/dist/orgchart.css";

export default {
    name: "About",
    components: {
        OrganizationChart,
    },
    data: () => ({
        api: "aboutus",

        // length: 3,
        window: 0,
        page: 1,
    }),
    head: {
        title: "About",
        htmlAttrs: {
            lang: "en",
        },
        meta: [
            { charset: "utf-8" },
            {
                name: "viewport",
                content: "width=device-width, initial-scale=1",
            },
            {
                hid: "description",
                name: "description",
                content: `LOGC About page give you more information about the story, vision, mission and organization chart of us`,
            },
            { name: "format-detection", content: "telephone=no" },
        ],
    },
    computed: {
        ...mapGetters({
            loading: "about/loading",
            information: "about/information",
        }),
    },
    async mounted() {
        if (
            !(
                this.information?.aboutUs &&
                this.information?.vision &&
                this.information?.mission &&
                this.information?.orgChart
            )
        ) {
            await this.$store.dispatch("about/getAboutUs");
        }
    },
};
